import { mapActions, mapState } from 'vuex';
import { dataURLtoBlob, blobToFile } from '@/assets/js/util';
import { uuid } from 'vue-uuid';
const oss = require('ali-oss');
let ossTimeName = null;

export const uploadMixin = {
  computed: {
    ...mapState('global', ['ossBeaseOptions']),
  },
  methods: {
    ...mapActions('global', ['getOssBeaseOptions']),
    clickUploadRef() {
      this.$refs.uploadInputRef.click();
    },
    initOssBease() {
      this.getOssBeaseOptions();
      //十分钟重新获取一次
      let ossTimeIndex = 10;
      ossTimeName = setInterval(() => {
        if (ossTimeIndex <= 0) {
          //清除定时器
          clearInterval(ossTimeName);
          //重新获取oss参数
          this.initOssBease();
        }
        ossTimeIndex -= 1;
      }, 60000);
    },
    uploadInputChange() {
      return new Promise((resolve, reject) => {
        const file = this.$refs.uploadInputRef.files;
        const fileType = file[0].type.toLowerCase();
        //判断文件类型
        if (!(fileType === 'image/png' || fileType === 'image/jpg' || fileType === 'image/jpeg')) {
          this.$message({
            message: '上传作品二维码格式错误',
            type: 'warning',
          });
          this.$refs.uploadInputRef.value = '';
          reject(false);
        }
        //判断图片大小
        if (file[0].size > this.maxImgSize) {
          this.$message({
            message: '上传作品二维码大小超出限制',
            type: 'warning',
          });
          this.$refs.uploadInputRef.value = '';
          reject(false);
        }
        const reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = (e) => {
          resolve(e.currentTarget.result);
        };
      });
    },
    uploadFileToOSS(url, requestUrl = 'cv/opus/') {
      return new Promise(async (resolve, reject) => {
        const fileName = `${uuid.v1()}.jpg`;
        const imageUrl = url;
        await this.getOssBeaseOptions();
        const store = await oss(this.ossBeaseOptions);
        let ossRes = {};

        //调用
        const blob = dataURLtoBlob(imageUrl);
        const fileData = blobToFile(blob, fileName);
        try {
          ossRes = await store.put(`${requestUrl}${fileName}`, fileData);
        } catch (error) {
          this.$message.error('图片上传失败');
          reject(false);
        } finally {
          this.$refs.uploadInputRef.value = '';
        }
        if (ossRes.res.statusCode !== 200) {
          this.$message.error('图片上传失败');
          reject(false);
        }
        resolve(ossRes.url);
      });
    },
  },
  created() {
    // this.initOssBease();
  },
};
